// removed by extract-text-webpack-plugin
module.exports = {"ChannelPaywall":"_2zVi0qNV9yPaGixWmP5x8I","description":"_1S-onXIKOnp9Uw-rNbXBV1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChannelPaywall/ChannelPaywall.css
// module id = 514
// module chunks = 0